import * as React from "react";
import { Archive, BookOpen, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const pillars = [{
  title: "Investment Holdings & Private Equity",
  description: "Through professional capital operations and risk management, we provide deep strategic investment and long‑term capital empowerment to high‑growth companies worldwide.",
  icon: Archive,
  link: "/GroupSectionPage"
}, {
  title: "Industrial Incubation & Project Management",
  description: "Leveraging SCI international think‑tank resources, we incubate quality projects and manage them throughout their lifecycle, facilitating global replication of innovative business models.",
  icon: Search,
  link: "/GroupSectionPage"
}, {
  title: "Media & MCN Operations",
  description: "Integrating media resources from both China and Singapore, we build an internationally influential brand communication system through digital marketing and a content matrix.",
  icon: BookOpen,
  link: "/GroupSectionPage"
}];
export default function PilaresAcademicos() {
  return <section data-section-id="223052" id="core-business-divisions" className="bg-background text-foreground py-20 px-4 md:px-8 lg:px-12">
      <div className="mx-auto max-w-screen-xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {pillars.map((pillar, i) => <Card key={i} data-index={i} className="border-border bg-card text-card-foreground hover:-translate-y-2 hover:shadow-2xl rounded-lg border shadow-sm transition-all duration-500">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex">
                  <pillar.icon className="text-primary h-12 w-12 stroke-[1.5]" />
                </div>
                <CardTitle className="font-default text-foreground text-2xl font-bold tracking-tight">
                  {pillar.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pb-6">
                <CardDescription className="font-default text-muted-foreground text-base leading-relaxed">
                  {pillar.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="ghost" asChild className="text-primary hover:bg-accent hover:text-accent-foreground rounded-md px-4 py-2 font-semibold transition-colors">
                  
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}